import React, { useState, useEffect } from 'react';
import { RunComponent } from '../components/Run';
import { ResponseContextProvider } from '../ResponseContext';
import { loadSupplemental } from 'js/actions/assessment-actions';
import { FullPageLoading } from 'js/components';
function CapabilitiesAssessmentRunEngine({ assessment, participant }) {
  const [supplemental, setSupplemental] = useState(null);

  useEffect(() => {
    loadSupplemental(assessment?.id).then((data) => {
      setSupplemental(data);
    });
  }, [assessment?.id]);

  if (!assessment || !supplemental) {
    return <FullPageLoading />;
  }

  return (
    <ResponseContextProvider assessment={assessment} participant={participant}>
      <RunComponent assessment={assessment} supplemental={supplemental} />
    </ResponseContextProvider>
  );
}

export default CapabilitiesAssessmentRunEngine;
